export enum LoginTypes {
    NoBroker = 1,
    Simulator = 2,
    Broker = 3
  }